angular.module("rental")
    .controller('RentalAgreementShowController', function (toastr, modals, $scope, $rootScope, $uibModalInstance, RentalAgreement, RentalAgreementConst, data, RentalAgreementService, RentalResourceService, Principal) {
        this.RentalAgreementService = RentalAgreementService
        this.RentalResourceService = RentalResourceService
        this.$onInit = () => {
            this.item = data
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
        }
        this.cancel = () => $uibModalInstance.dismiss()
    })
